import 'slick-carousel/slick/slick'

export default class OurClientsSlider {

    constructor() {

        this.settings = {
            $el : $('.js-our-clients-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        $('.js-our-clients-slider').each(function () {

            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                prevArrow: $('.js-our-clients-slider-previous'),
                nextArrow: $('.js-our-clients-slider-next'),
                dots: true,
                appendDots: $('.js-our-clients-slider-dots'),
            });
        })

    }

};

new OurClientsSlider();